import {createReducer} from '@reduxjs/toolkit';

import {endTour, runTour, setTour, setTourIndex} from '../actions/tour.js';

import {TOURS, TOUR_STEPS} from '@app/constants/tour.jsx';

const emptyTour = TOURS.EMPTY_STATE;

export const initialState = {
  run: false,
  index: 0,
  tour: emptyTour,
  steps: TOUR_STEPS[emptyTour],
};

const tour = createReducer(initialState, builder => {
  builder.addCase(runTour, (state, {payload}) => {
    state.run = payload;
  });

  builder.addCase(setTour, (state, {payload}) => {
    const tour = payload ? payload : emptyTour;
    state.tour = tour;
    state.index = 0;
    state.steps = TOUR_STEPS[tour];
    state.run = true;
  });

  builder.addCase(setTourIndex, (state, {payload: index}) => {
    state.index = index;
  });

  builder.addCase(endTour, () => initialState);
});

export default tour;
